import _asyncToGenerator from "/data/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-7552358e"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "department-tree-container"
};

const _hoisted_2 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("确定");

import { ref, computed, watch } from 'vue';
import { ElMessage } from 'element-plus';
import Axios from '@/request/createAxiosInstalce';
export default {
  name: 'DepartmentTreeModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    supplierId: {
      type: String,
      default: ''
    }
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });
    const treeRef = ref();
    const departmentTree = ref([]);
    const selectedDepartment = ref(null);
    const treeProps = {
      children: 'children',
      label: 'text',
      disabled: data => {
        // 根节点不支持选择
        return data.levelType === '0';
      }
    }; // 获取部门树数据

    function getDepartmentTree() {
      return _getDepartmentTree.apply(this, arguments);
    } // 处理树节点选择（强制单选：始终保留最后一次点击的节点）


    function _getDepartmentTree() {
      _getDepartmentTree = _asyncToGenerator(function* () {
        if (!props.supplierId) {
          ElMessage.warning('缺少供应商ID');
          return;
        }

        try {
          const response = yield Axios.get('/admin/structure/getStructureTreeInfo.json', {
            params: {
              supplierId: props.supplierId
            }
          });

          if (response.data && Array.isArray(response.data)) {
            departmentTree.value = response.data;
          } else {
            ElMessage.error('获取部门树数据失败');
          }
        } catch (error) {
          console.error('获取部门树失败:', error);
          ElMessage.error('获取部门树失败');
        }
      });
      return _getDepartmentTree.apply(this, arguments);
    }

    function handleCheck(data, checkedInfo) {
      const {
        checkedKeys
      } = checkedInfo;
      const isChecked = checkedKeys.includes(data.id);

      if (isChecked) {
        // 仅保留当前点击节点
        treeRef.value.setCheckedKeys([data.id]);
        selectedDepartment.value = data;
      } else {
        // 取消当前点击节点即清空
        treeRef.value.setCheckedKeys([]);
        selectedDepartment.value = null;
      }
    } // 根据ID查找节点


    function findNodeById(nodes, id) {
      for (const node of nodes) {
        if (node.id === id) {
          return node;
        }

        if (node.children && node.children.length > 0) {
          const found = findNodeById(node.children, id);
          if (found) return found;
        }
      }

      return null;
    } // 确认选择


    function confirm() {
      if (!selectedDepartment.value) {
        ElMessage.warning('请选择部门');
        return;
      }

      emit('success', selectedDepartment.value);
      visible.value = false;
      departmentTree.value = [];
    } // 监听弹窗打开


    watch(() => props.modelValue, newVal => {
      if (newVal) {
        selectedDepartment.value = null;
        getDepartmentTree();
      }
    });
    return (_ctx, _cache) => {
      const _component_el_tree = _resolveComponent("el-tree");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        title: "选择部门",
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _isRef(visible) ? visible.value = $event : null),
        width: "500px",
        "destroy-on-close": "",
        "append-to-body": ""
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[0] || (_cache[0] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: confirm,
          disabled: !selectedDepartment.value
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        }, 8, ["disabled"])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_tree, {
          ref_key: "treeRef",
          ref: treeRef,
          data: departmentTree.value,
          props: treeProps,
          "node-key": "id",
          "default-expand-all": true,
          "highlight-current": true,
          "check-strictly": true,
          "show-checkbox": "",
          onCheck: handleCheck,
          class: "department-tree"
        }, null, 8, ["data"])])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }

};